import React from 'react';
import PropTypes from 'prop-types';

import CheckBox from 'components/CheckBox';
import { linearModel } from 'mobx-store';

import { SCATTER_PLOT_TYPES } from 'mobx-store/linearModel';
class ScatterPlotHeaderComponent extends React.PureComponent {
  static propTypes = {
    showRegressionLine: PropTypes.bool.isRequired,
    showConfidenceIntervals: PropTypes.bool.isRequired,

    onRegressionLineCheckboxChange: PropTypes.func.isRequired,
    onConfidenceIntervalsCheckboxChange: PropTypes.func.isRequired,
    type: PropTypes.oneOf([
      SCATTER_PLOT_TYPES.MAIN,
      SCATTER_PLOT_TYPES.NORMAL,
      SCATTER_PLOT_TYPES.RESIDUALS
    ]).isRequired
  }

  componentDidMount () {
    linearModel.visibleScatterPlotType = this.props.type;
  }

  checkBoxLabel = () =>
    this.props.type === SCATTER_PLOT_TYPES.NORMAL
      ? 'Overlay Line'
      : 'Regression Line'

  render () {
    return (
      <div className="flex space-between mb-20">
        <CheckBox
          checked={this.props.showRegressionLine}
          onChange={this.props.onRegressionLineCheckboxChange}
          testId="checkBoxRegressionLine"
        >
          {this.checkBoxLabel()}
        </CheckBox>

        {this.props.type === SCATTER_PLOT_TYPES.MAIN &&
          <CheckBox
            checked={this.props.showConfidenceIntervals}
            onChange={this.props.onConfidenceIntervalsCheckboxChange}
            testId="checkBoxConfidenceBands"
          >

            Confidence Bands
          </CheckBox>
        }
      </div>
    );
  }
}

export default ScatterPlotHeaderComponent;
